/**
 * State used in rendering TableCellLayout
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
